
import React, { useEffect } from "react";

interface EmergencyFallbackProps {
  message?: string;
}

export const EmergencyFallback: React.FC<EmergencyFallbackProps> = ({ 
  message = "LiveTrack is starting up..." 
}) => {
  useEffect(() => {
    console.log('[EmergencyFallback] Rendering emergency fallback:', message);
    
    // Force absolute visibility
    document.body.style.cssText = `
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      background-color: #ffffff !important;
      margin: 0 !important;
      padding: 0 !important;
    `;
    
    const root = document.getElementById('root');
    if (root) {
      root.style.cssText = `
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        height: 100% !important;
        width: 100% !important;
        background-color: #ffffff !important;
      `;
    }
  }, [message]);

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        zIndex: 9999,
        fontFamily: '-apple-system, system-ui, sans-serif'
      }}
      data-testid="emergency-fallback"
    >
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        maxWidth: '400px'
      }}>
        <h1 style={{ 
          fontSize: '2rem', 
          marginBottom: '1rem',
          color: '#1f2937',
          fontWeight: 'bold'
        }}>
          LiveTrack
        </h1>
        <p style={{ 
          color: '#6b7280',
          marginBottom: '1rem',
          fontSize: '1rem'
        }}>
          {message}
        </p>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e5e7eb',
          borderTop: '4px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: '2rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: '#3b82f6',
            color: '#ffffff',
            border: 'none',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
        >
          Refresh Page
        </button>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );
};
